import { Card, Button } from "@120wateraudit/waterworks";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
import { Carousel } from "react-responsive-carousel";

import Loader from "src/components/Loader";
import { useDeleteContactMutation } from "src/services";
import { Contact } from "src/types/Contact";
import NoContact from "./NoContact";
import ContactDataVersionTwo from "./ContactDataVersionTwo";

interface Props {
  className?: string;
  contacts: Contact[];
  style?: React.CSSProperties;
}

const ContactsCard: React.FC<Props> = ({ className, contacts, style }) => {
  const [deleteContact, { isLoading: isDeleting }] = useDeleteContactMutation();
  const onDelete = async (contact: Contact): Promise<void> =>
    await deleteContact({
      contactId: contact.id,
      systemId: contact.pwsId,
    }).unwrap();

  const noContacts = contacts.length === 0;

  if (noContacts || isDeleting) {
    return (
      <Card style={style}>
        <ContactHeader>Contact Information</ContactHeader>
        {noContacts && <NoContact />}
        {isDeleting && <Loader />}
      </Card>
    );
  }

  return (
    <Card style={style} className={className}>
      <CarouselHeader>Contact Information</CarouselHeader>
      <Carousel
        showStatus={false}
        showThumbs={false}
        showIndicators={false}
        renderArrowPrev={(onClickHandler, hasPrev) =>
          hasPrev && (
            <LeftChevron onClick={onClickHandler} aria-label="Previous contact">
              <FontAwesomeIcon icon={solid("chevron-left")} size="sm" />
            </LeftChevron>
          )
        }
        renderArrowNext={(onClickHandler, hasNext) =>
          hasNext && (
            <RightChevron onClick={onClickHandler} aria-label="Next contact">
              <FontAwesomeIcon icon={solid("chevron-right")} size="sm" />
            </RightChevron>
          )
        }
      >
        {contacts.map((contact) => {
          return (
            <ContactDataVersionTwo
              contact={contact}
              key={contact.id}
              onDelete={onDelete}
            />
          );
        })}
      </Carousel>
    </Card>
  );
};
const ContactHeader = styled.p`
  margin-top: 0px;
  font-weight: 600;
`;

const RightChevron = styled(Button)`
  border: none;
  box-shadow: none;
  position: absolute;
  background: transparent;
  top: -40px;
  right: 1%;
  z-index: 10;
  padding-left: 10px;
  padding-right: 10px;
`;

const LeftChevron = styled(Button)`
  border: none;
  box-shadow: none;
  position: absolute;
  background: transparent;
  top: -40px;
  right: 40px;
  z-index: 10;
  padding-left: 10px;
  padding-right: 10px;
`;

const CarouselHeader = styled.p`
  margin-top: 0px;
  font-weight: 600;
  &&& {
    text-align: left;
  }
`;

export default ContactsCard;
